/**
 * Helper types/functions to bubble up errors from services to UI
 */

export type Result<T, E> = { ok: true, value: T } | { ok: false, error: E };

export const okResult = <T>(value: T): Result<T, never> => ({ ok: true, value });

export const errResult = <E>(error: E): Result<never, E> => ({ ok: false, error });
